module.exports = __webpack_public_path__ + "img/new-zealand.95980890.svg";